import { createContext } from "react";

/**
 * DOM id of the embed currently rendering. `EmbedFrame` provides it (and sets it
 * as the id on the embed's DOM node); `useQuery` reads it so every query carries
 * its embed id, letting a click in the live-tasks card scroll back to the embed.
 * Empty string when not inside an embed.
 */
export const EmbedIdContext = createContext<string>("");

/** Freshness of an embed's rendered result — when it was fetched and whether
 * it's live/cached/stale — surfaced as the embed's data-age hover title. */
export interface EmbedResultMeta {
  /** ISO timestamp the cached result was produced (from QueryResult.cachedAt). */
  cachedAt?: string;
  /** "live" (just executed) or "cache" (served from disk). */
  source?: string;
  /** True when the server served a stale cache and kicked a background refresh. */
  stale?: boolean;
}

/**
 * Callback `useQuery` calls with its result's freshness; `EmbedFrame` provides it
 * and renders the age as the embed's hover title. Default no-op (outside a frame).
 */
export const EmbedReportContext = createContext<(m: EmbedResultMeta | null) => void>(
  () => {},
);
